import type { UserRole as UserRoleType } from "Infrastructure/Api/Api";
import { ToolpadSignInPage } from "Infrastructure/Components/Auth/ToolpadSignInPage";
import { useAuth } from "Infrastructure/Contexts/AuthContext";
import { Box, CircularProgress, Stack } from "@mui/material";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Navbar } from "./Navbar/Navbar";

type LayoutProps = {
  children: ReactNode;
  allowedRoles?: UserRoleType[];
  redirectTo?: string;
};

export const AuthenticatedLayout = ({
  children,
  allowedRoles,
  redirectTo = "/403",
}: LayoutProps) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Stack
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={0}
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress />
      </Stack>
    );
  }

  if (!isAuthenticated) {
    return <ToolpadSignInPage />;
  }

  if (allowedRoles && user?.role && !allowedRoles.includes(user.role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <Box>
      {user && <Navbar user={user} />}
      <Box>{children}</Box>
    </Box>
  );
};
